import React, { useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import { getReservationDetails } from "redux/actions/UserTrip";
import Loader from "components/loader/Loader";
import { dateFormate, getReservationDetailsObject } from "utils/utils";
import { bookingDetailsData, bookingTime } from "./RideTrackData";
import Wifi from "assets/images/Wifi.svg";
import Snack from "assets/images/Snack.svg";
import Charger from "assets/images/Charger.svg";
import NewsPaper from "assets/images/NewsPaper.svg";
import WaterBottle from "assets/images/WaterBottle.svg";

function BookingDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { state } = location;
  const [searchParams, setSearchParams] = useSearchParams();
  const id = searchParams.get("id") || "a3ddcb67-d84e-4551-aafb-eeef7506f68b";
  const startDate = searchParams.get("startDate");
  const endDate = searchParams.get("endDate");
  const type = searchParams.get("type");
  const page = searchParams.get("page");
  const rowsPerPage = searchParams.get("rowsPerPage");
  const search = searchParams.get("search");
  const tab = searchParams.get("tab");

  const tripDetails = useSelector(
    (state) => state.getReservationDetails?.reservationDetails?.data
  );
  const details = getReservationDetailsObject(tripDetails);
  const CabFacilities = tripDetails?.facilities;

  const reservationDataLoading = useSelector(
    (state) => state.getReservationDetails?.loading
  );

  useEffect(() => {
    dispatch(getReservationDetails(id));
  }, []);

  const filterValue = (key) => {
    if (key === "Special Instruction" && tripDetails?.DriverProfile) {
      return "";
    }
    if (
      key === "Rep. Address" ||
      key === "Drop Address" ||
      key === "Via Address" ||
      key === "Special Instruction" ||
      key === "Trip Charges"
    ) {
      return "expandRow";
    }
  };

  const handleBackBtn = () => {
    navigate(
      `/rideTrack/${tab}?startDate=${startDate || null}&endDate=${
        endDate || null
      }&page=${page}&rowsPerPage=${rowsPerPage}&search=${search || ""}`
    );
  };

  // ---For Image Error---
  const handleOnError = (e, facilityName) => {
    let replacementImage;
    switch (facilityName) {
      case "Wifi":
        replacementImage = Wifi;
        break;
      case "Snack":
        replacementImage = Snack;
        break;
      case "Charger":
        replacementImage = Charger;
        break;
      case "News Paper":
        replacementImage = NewsPaper;
        break;
      case "Water Bottel":
        replacementImage = WaterBottle;
        break;
      default:
        replacementImage = Wifi;
    }
    e.target.src = replacementImage;
  };

  return (
    <div>
      {reservationDataLoading ? (
        <Loader />
      ) : (
        <Box>
          <Grid container className="pb20 justifyBetween">
            <Box className="flexAlignCenter" alignItems={"center"}>
              <ArrowBackIosRoundedIcon
                className="font24 colorGrey cursor"
                role="presentation"
                onClick={() => handleBackBtn()}
              />
              <Typography variant={"head4"} className="colorPrimary pl10">
                Booking ID #{tripDetails?.tripId}
              </Typography>
            </Box>
          </Grid>
          <Box className="dashedBorderBottom"></Box>
          <Grid container justifyContent={"center"}>
            <Grid item xs={11}>
              <Grid container className="ptb30 justifyBetween">
                <Typography variant="head5" className="fw600 colorBlack">
                  Booking Details&nbsp;
                  <span className="font14 fw400">
                    ({dateFormate(tripDetails?.updatedAt, "fromNowFormat")})
                  </span>
                </Typography>
              </Grid>
              <Grid container className="ptb20 mb20 bgLightOrange">
                {bookingTime &&
                  bookingTime(tripDetails).map((data, index) => (
                    <Grid
                      key={index}
                      item
                      xs={12}
                      sm={3}
                      sx={{
                        padding: { xs: "20px 0px 0px 20px", sm: "0px" },
                        justifyContent: { xs: "flex-start", sm: "center" },
                      }}
                      container
                      className="justifyCenter"
                    >
                      <Box className="flex">
                        <img src={data.img} alt="Logo" />
                      </Box>
                      <Typography variant={"body2"} className="colorBlack pl20">
                        {data.title || "NA"}
                      </Typography>
                    </Grid>
                  ))}
              </Grid>
              <Grid container className="mt40 mb20">
                {bookingDetailsData(tripDetails, details) &&
                  bookingDetailsData(tripDetails, details).map((value, key) => (
                    <Grid
                      key={key}
                      item
                      xs={12}
                      md={filterValue(value?.title, value?.status) ? 12 : 6}
                      sx={{ display: value?.title ? "flex" : "none" }}
                      container
                    >
                      <Grid
                        xs={4}
                        md={filterValue(value?.title, value?.status) ? 2 : 4}
                        item
                        className="p20 alignStart gridBorder"
                      >
                        <Typography variant={"body2"} className="colorGrey">
                          {value.title || "NA"}
                        </Typography>
                      </Grid>

                      <Grid
                        xs={8}
                        md={filterValue(value?.title, value?.status) ? 10 : 8}
                        item
                        flexWrap={"wrap"}
                        className="p20 alignStart gridBorder"
                      >
                        <Typography
                          variant={`${
                            value?.textType === "textBold" ? "head5" : "body2"
                          }`}
                          className={`pr10 ${
                            value?.textType === "textBold" && "fw700"
                          }`}
                        >
                          {value.data || "NA"}
                        </Typography>
                        {value?.inclusive && (
                          <Typography variant={"body3"} className={"colorGrey"}>
                            (Exclusive of GST and Toll & Parking)
                          </Typography>
                        )}
                        {value.title === "Passenger Name" && value.isVip && (
                          <Typography variant={"body5"} className="vipBadge">
                            VIP
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                  ))}
              </Grid>
            </Grid>
          </Grid>
          <Grid container justifyContent={"center"}>
            <Grid item xs={11}>
                  <Typography
                    variant="head5"
                    component={"h2"}
                    className="colorBlack fw600 mb20"
                  >
                    Facilities
                  </Typography>

                  <Grid container className="mt30 mb20">
                    {CabFacilities?.length ? (
                      CabFacilities?.map((row, index) => (
                        <Grid
                          item
                          md={2.4}
                          sm={6}
                          xs={12}
                          key={index}
                          className="facilityDashBoarder"
                        >
                          <Box className="justifyCenter ptb20">
                            <Box className="dflex" alignItems={"center"}>
                              <img
                                src={row?.img?.url}
                                alt="Logo"
                                className="wh40-ObjectFit"
                                onError={(e) => handleOnError(e, row?.name)}
                              />
                            </Box>
                            <Typography
                              variant="body2"
                              className="colorGrey pl20"
                            >
                              {row?.name || "NA"}
                            </Typography>
                          </Box>
                        </Grid>
                      ))
                    ) : (
                      <Typography variant="body2" className="colorGrey pl20">
                        No Facilites Available
                      </Typography>
                    )}
                  </Grid>
                  </Grid>
                  </Grid>
        </Box>
      )}
    </div>
  );
}

export default BookingDetails;
